jQuery(document).ready(function ($) {
    // Auto resize the textarea
    autosize();

    function autosize() {
        var text = $('.bocss-textarea');

        text.each(function () {
            $(this).attr('rows', 1);
            resize($(this));
        });

        text.on('input', function () {
            resize($(this));
        });

        function resize($text) {
            $text.css('height', 'auto');
            if ($text[0].scrollHeight === 0) {
                $text.css('height', '40px');
            } else if ($text[0].scrollHeight ) {
                $text.css('height', $text[0].scrollHeight + 'px');
            }
        }
    }

    function leaveInput(el) {
        if (el.value.length > 0) {
            if (!el.classList.contains('active')) {
                el.classList.add('active');
            }
        } else {
            if (el.classList.contains('active')) {
                el.classList.remove('active');
            }
        }
    }

    var inputs = document.getElementsByClassName("bocss-textarea");
    for (var i = 0; i < inputs.length; i++) {
        var el = inputs[i];
        el.addEventListener("blur", function () {
            leaveInput(this);
        });
    }

    $('.bocss-textarea__group').each(function () {
        var span = $(this).find('span.charcount');
        var text = $(this).find('.bocss-textarea');
        text.keyup(function () {
            var textMax = text.attr('maxlength');
            if(typeof textMax !== typeof undefined && textMax !== false){
                var value = $(this).val();
                var count = value.length;
                span.text(count + '/' + textMax);
            }
        });
    });
});
